import { PricingAnalyticsDataContext } from 'contexts/PricingAnalyticsContext';
import KpiComparisonCards from './KpiComparisonCards/KpiComparisonCards';
import ComparisonTableContainer from './ComparisonTableContainer';
import { useContext, useState } from 'react';
import { Switch } from 'antd';
import LensConfigManger from '../LensConfigManager/LensConfigManger';
import { LenseAttribute, LenseConfig, tabsType } from 'types/pricingSimulator';
import ScenarioFilter from '../ScenarioFilter/ScenarioFilter';
import _ from 'lodash';
import { filterOutDisplayOnlyAttributes } from 'utils/helperMethods';
import FilterRibbon from '../FilterRibbon/FilterRibbon';
import TabSwitchComponent from 'components/atoms/TabSwitch/TabSwitch';

const ScenarioComparisonContainer = () => {
    const {
        scenarioComparisonState,
        selectedReportInfo,
        lenseConfigLoading,
        updateReportProperty,
        showOldValue,
        setShowOldValue,
        availableFilters,
        allCheckedAttribute,
        allSelectedValueForAllAttribute,
        applyFilterObject,
        resetFilterObject,
        showIsEditedRecords,
        setShowIsEditedRecords,
        setAllCheckedAttribute,
        setAllSelectedValueForAllAttribute,
        setApplyFilterObject,
        saveFilterConfig,
    } = useContext(PricingAnalyticsDataContext);

    const disableSearchFilterButton = false;
    const [showDeltaInfo, setShowDeltaInfo] = useState(false);

    const oldNewTabs: tabsType[] = [
        {
            key: 'old',
            label: 'Old Value',
        },
        {
            key: 'new',
            label: 'New Value',
        },
    ];

    return (
        <div id="scenario-comparison-container">
            {/* HEADER AND ACTIONS  */}
            <div className="flex justify-between items-center my-6">
                <span className="text-black font-lg">Compare Scenarios</span>
                <div className={`flex items-center gap-2  `}>
                    {/* SWITCH */}
                    <div className="flex gap-1 items-center">
                        <Switch checked={showDeltaInfo} onChange={(checked) => setShowDeltaInfo(checked)} />
                        <span className="text-promoColour font-xxs">Delta</span>
                    </div>
                    <TabSwitchComponent
                        activeTabKey={showOldValue ? 'old' : 'new'}
                        onTabChange={(tab: tabsType) => setShowOldValue(tab.key === 'old')}
                        tabs={oldNewTabs}
                    />
                    {/* KPI SELECT COMPONENT */}
                    <div className="flex justify-center items-center">
                        <span className="mr-2">Select KPIs</span>
                        <LensConfigManger
                            buttonName={'Multiple Selections'}
                            initialConfigDetails={filterOutDisplayOnlyAttributes(
                                selectedReportInfo?.baseKPIs?.kpiConfig || [],
                            )}
                            onSubmitHandler={(updatedDetails: LenseConfig[]) => {
                                if (selectedReportInfo) {
                                    const updatedKpis: number[] = [];
                                    updatedDetails?.forEach((c: LenseConfig) => {
                                        c.attributes.forEach((a: LenseAttribute) => {
                                            if (a.isSelected) {
                                                updatedKpis.push(a.attributeId);
                                            }
                                        });
                                    });
                                    updateReportProperty('baseKPIs', {
                                        ...selectedReportInfo?.baseKPIs,
                                        kpiConfig: updatedDetails,
                                        selectedKPIs: updatedKpis.filter(
                                            (value, index, self) => self.indexOf(value) === index,
                                        ),
                                    });
                                }
                            }}
                            showAttributePanelToTheRight={false}
                            placeHolderLabel="Search Kpis..."
                            saveButtonLabel="Add Selected"
                            noOutputCall={true}
                            disabled={lenseConfigLoading}
                        />
                    </div>

                    {/* FILTER */}
                    <ScenarioFilter
                        disabled={disableSearchFilterButton}
                        availableFilters={availableFilters}
                        allCheckedAttribute={allCheckedAttribute}
                        allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                        applyFilterObject={applyFilterObject}
                        resetFilterObject={resetFilterObject}
                        scenarioId={selectedReportInfo?.baseScenario?.scenarioId || 0}
                        onSubmitHandler={(resultObj: any) => {
                            setAllCheckedAttribute(resultObj.allCheckedAttribute);
                            setAllSelectedValueForAllAttribute(resultObj.allSelectedValueForAllAttribute);
                            setShowIsEditedRecords(resultObj?.showIsEditedRecords);
                            setApplyFilterObject(resultObj.applyFilterObject);

                            saveFilterConfig(resultObj);
                        }}
                        showAttributePanelToLeft={true}
                        hideShowEditedRecordCheckbox
                    />
                    {/* EXPORT  */}
                    {/* <div className="w-16"> </div> */}
                </div>
            </div>

            {/*3.  Filter Ribbon  */}
            <div className="my-3">
                <FilterRibbon
                    allCheckedAttribute={allCheckedAttribute}
                    allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                    applyFilterObject={applyFilterObject}
                    resetFilterObject={resetFilterObject}
                    onSubmitHandler={(obj: any) => {
                        setAllCheckedAttribute(obj.allCheckedAttribute);
                        setAllSelectedValueForAllAttribute(obj.allSelectedValueForAllAttribute);
                        setApplyFilterObject(obj.applyFilterObject);
                        saveFilterConfig(obj);
                    }}
                />
            </div>

            {/* CARDS CONTAINER */}
            <KpiComparisonCards
                scenarioIds={
                    scenarioComparisonState?.selectedScenarios?.map((s) => s.scenarioId) || [
                        selectedReportInfo?.baseScenario.scenarioId || 0,
                    ]
                }
                showDeltaInfo={showDeltaInfo}
            />

            {/* TABLE CONTAINER */}
            {scenarioComparisonState?.selectedKpiItem?.id && <ComparisonTableContainer />}
        </div>
    );
};

export default ScenarioComparisonContainer;
